import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import VueGoogleMaps from '@fawmi/vue-google-maps';

import '@/assets/css/modern.css'
// import '@/assets/js/settings'
import '@/assets/js/app'

import '@/assets/css/base.css'
import { initAutoResizeTextarea } from '@/assets/js/autoResizeTextarea'

initAutoResizeTextarea();

import ApiService from '@/assets/js/apiService'; // 引入 ApiService 實例
import Parameters from '@/assets/js/parameters'
import shareds from '@/assets/js/shared'

const Gmap = {
    load:{
        key:process.env.VUE_APP_GOOGLE_MAP_KEY
    }
}


const app = createApp(App);

//全域取代掉this.$debug
app.config.globalProperties.$debug = (...args)=>{
    const devBugMode = localStorage.getItem('devBugMode') ? Boolean(localStorage.getItem('devBugMode')) : false
    if ( 
        process.env.VUE_APP_TEST_ENV == 'production' &&
        devBugMode == false
    ){
        window.console.log = ()=>{}
        return
    }
    console.log(...args);
};
// window.console.log = ()=>{}
// 創建 ApiService 實例並將 router 傳遞給它
const apiService = new ApiService(app);
const parameters = new Parameters()
const shared = new shareds()

app.config.globalProperties.$api = apiService;
app.config.globalProperties.$parameters = parameters;
app.config.globalProperties.$shared = shared;

apiService.debug = app.config.globalProperties.$debug
apiService.router = router
apiService.store = store


import SampleData from '@/assets/js/sampleData'; // 引入 SampleData 實例
const sampleData = new SampleData();
app.config.globalProperties.$sampleData = sampleData;

app.use(i18n)
app.use(store)
app.use(router)
app.use(VueGoogleMaps, Gmap)
app.mount('#app');
